import { Datepicker, FilterSidebar } from "#/molecules";
import { FC, memo, useCallback } from "react";
import { InputText, Select } from "#/atoms";
import { getOrderStateArray, getOrderStateText } from "@/helpers";
import { useDatepicker, useInput, useSelect } from "@/hooks";

import { FilterOrdersProps } from "./Orders.interface";
import { ORDER_STATE } from "@/types";

const Orders: FC<FilterOrdersProps> = ({ filter, numberOfFilters, onCloseFilter, onClearFilter, onFilter, showAdminFilter }) => {
  const companyName = useInput(filter?.companyName);
  const customerCode = useInput(filter?.customerCode);
  const customerEmail = useInput(filter?.customerEmail);
  const dateOrderTaken = useDatepicker(filter?.dateOrderTaken ? new Date(filter?.dateOrderTaken) : null);
  const dateWorkToBeDone = useDatepicker(filter?.dateWorkToBeDone ? new Date(filter?.dateWorkToBeDone) : null);
  const jobNumber = useInput(filter?.jobNumber);
  const location = useInput(filter?.location);
  const orderRef = useInput(filter?.orderRef);
  const state = useSelect(getOrderStateText(filter?.state));
  const workerId = useInput(filter?.workerId);

  const handleFilter = useCallback(() => {
    onFilter({
      companyName: companyName.value,
      customerCode: customerCode.value,
      customerEmail: customerEmail.value,
      dateFrom: '',
      dateOrderTaken: dateOrderTaken.value?.toString() || '',
      dateTo: '',
      dateWorkToBeDone: dateWorkToBeDone.value?.toString() || '',
      jobNumber: jobNumber.value,
      location: location.value,
      orderRef: orderRef.value,
      state: state.value as unknown as ORDER_STATE,
      workerId: workerId.value
    });
  }, [
    companyName,
    customerCode,
    customerEmail,
    dateOrderTaken,
    dateWorkToBeDone,
    jobNumber,
    location,
    orderRef,
    state,
    workerId
  ]);

  const handleClear = () => {
      jobNumber.setValue('');
      dateOrderTaken.setValue(null);
      dateWorkToBeDone.setValue(null);
      customerCode.setValue('');
      companyName.setValue('');
      customerEmail.setValue('');
      workerId.setValue('');
      orderRef.setValue('');
      location.setValue('');
      state.setValue('');
      onClearFilter();
  }

  const options = [{ id: '', label: ''} , ...getOrderStateArray()];

  return (
    <FilterSidebar
      numberOfFilters={numberOfFilters}
      onClearFilters={handleClear}
      onClose={onCloseFilter}
      onFilter={handleFilter}
    >
      <InputText type="text" label="Job Number" fullWidth value={jobNumber.value} onChange={jobNumber.onChange} />
      
      { showAdminFilter && (<>
      <Datepicker label="Date Order Taken" date={dateOrderTaken.value} onChange={dateOrderTaken.onChange} />
      <Datepicker label="Date Work To Be Done" date={dateWorkToBeDone.value} onChange={dateWorkToBeDone.onChange} />
      <InputText type="text" label="Customer Code" fullWidth value={customerCode.value} onChange={customerCode.onChange} />
      <InputText type="text" label="Company Name" fullWidth value={companyName.value} onChange={companyName.onChange} />
      <InputText type="text" label="Customer E-mail" fullWidth value={customerEmail.value} onChange={customerEmail.onChange} />
      <InputText type="text" label="Photoplanner " fullWidth value={workerId.value} onChange={workerId.onChange} />     
      <InputText type="text" label="Package" fullWidth value={orderRef.value} onChange={orderRef.onChange} /></>) }
      <InputText type="text" label="Address Details" fullWidth value={location.value} onChange={location.onChange} />
      
      <Select label="Order Status" options={options} selected={state.value} onChange={state.onChange} />
    </FilterSidebar>
  );
}

export default memo(Orders);
